

























































































































































































































































































































































































































































































































































































































































































































import { Component } from "vue-property-decorator";

import MapUI from "@/components/map/MapUI.vue";
import ControlsUI from "@/components/map/ControlsUI.vue";
import ScaleCoordinateUI from "@/components/map/ScaleCoordinateUI.vue";
import LegendUI from "@/components/map/LegendUI.vue";
import TreeListUI from "@/components/shared/TreeListUI.vue";
import PropertyUI from "@/components/shared/PropertyUI.vue";
import WindowUI from "@/components/shared/WindowUI.vue";
import DialogUI from "@/components/shared/DialogUI.vue";
import GISagroLandClass from "./gisagro.land.class";

import SearchLand from "./toc/search.land.vue";
import DownloadLand from "./toc/download.land.vue";

import Help from "./toc/help.vue";
import UserProfile from "./toc/user.profile.vue";
import AdminUsers from "./toc/admin.users.vue";
import AdminAddUser from "./toc/admin.adduser.vue";
import AdminUserLogs from "./toc/admin.userlogs.vue";
import OnlineUsers from "./toc/online.users.vue";

@Component({
  components: {
    'ol-map': MapUI,
    'ol-controls': ControlsUI,
    'ol-scale-coordinate': ScaleCoordinateUI,
    'v-legend': LegendUI, 
    'v-tree-list': TreeListUI,
    'v-property': PropertyUI,
    'v-window': WindowUI,
    'v-dialog': DialogUI,
    'SEARCH': SearchLand,
    'DOWNLOAD': DownloadLand,
    'help': Help,
    'user_profile': UserProfile,
    'admin_users': AdminUsers,
    'admin_userlogs': AdminUserLogs,
    'admin_adduser': AdminAddUser,
    'online_users': OnlineUsers
  }
})
export default class Land extends GISagroLandClass {
  async created() {
    window.addEventListener('beforeunload', this.clearOpener);
    this.initialize();
  };

  mounted() {
    this.DrawerHeight = window.innerHeight - 76;
    this.clockInterval = setInterval(() => {
      let d = new Date();
      let hh = ('0' + d.getHours()).slice(-2);
      let mm = ('0' + d.getMinutes()).slice(-2);
      let ss = ('0' + d.getSeconds()).slice(-2);
      let yy = d.getFullYear() + 543;
      let MM = ('0' + (d.getMonth() + 1)).slice(-2);
      let dd = ('0' + d.getDate()).slice(-2); 
      this.timeNow = dd + '-' + MM + '-' + yy + ' ' + hh + ':' + mm + ':' + ss;
    }, 1000);
  };

  beforeDestroy() {
    clearInterval(this.clockInterval);
  };

  //XX showMapError(error) {
  //  this.alertError(error.message || error);
  //}

  disableTool(tool) {
    return !this.ICanEdit || (tool.enabledZoomLevel!=undefined ? 
           (this.zoom<tool.enabledZoomLevel) : tool.isEnabled===false);
  }
}
